import formatProduct from 'util/format-product';
import getProductNameFromUrl from 'util/get-product-name-from-url';
import getProductType from 'util/get-product-type';

import getHeroProductByStore from 'data/get-hero-product-by-store';
import getProductByHandle from 'data/get-product-by-handle';
import type { Connection, Product, ProductConf } from 'types';
import type { Currency } from 'types';

async function getProductFromHeroProduct({
  heroProductUrl,
  productIdExtractCode,
  storeId,
  currencyConversionRate,
  customerCurrency
}: {
  heroProductUrl: string;
  productIdExtractCode?: string;
  currencyConversionRate: number;
  customerCurrency?: string | null;
  storeId: string;
}): Promise<Product | undefined> {
  const productName = getProductNameFromUrl(heroProductUrl, productIdExtractCode);
  if (productName) {
    const productDetails = await getProductByHandle({
      currencyConversionRate,
      customerCurrency,
      productName,
      storeId
    });
    if (productDetails) return productDetails;
  } else {
    console.warn({ message: `Failed to get product form productIdExtractCode` });
  }
}

const loadInitialProduct = async ({
  storeId,
  currency,
  connection,
  currencyConversionRate,
  customerCurrency
}: {
  storeId: string;
  currency?: Currency;
  connection: Connection;
  productConf?: ProductConf;
  currencyConversionRate: number;
  customerCurrency?: string | null;
}): Promise<{ productUrl?: string; product?: Product; productType?: string }> => {
  const { productIdExtractCode, productTypeExtractCode } = connection;
  const productUrl = window.location.href.split('?')[0];
  sessionStorage.setItem('currentProductURL', window.location.href);
  const productName = getProductNameFromUrl(productUrl, productIdExtractCode);

  if (productName) {
    const productDetails = await getProductByHandle({ currencyConversionRate, customerCurrency, productName, storeId });
    if (productDetails) {
      const product = formatProduct(productDetails, currency);
      return { product, productType: product.productType, productUrl };
    } else {
      console.warn({ message: `Failed to get product form productIdExtractCode` });
    }
  }

  let heroProductUrl;
  let productType;
  if (productTypeExtractCode) {
    productType = getProductType(productTypeExtractCode);
    if (productType) {
      heroProductUrl = await getHeroProductByStore({ productType, storeId });
      console.debug({
        heroProduct: heroProductUrl || 'N/A',
        message: `Hero product for Current product type`,
        productType
      });
    } else {
      console.warn({ message: `Failed to get product form productTypeExtractCode` });
    }
  }

  if (heroProductUrl) {
    const productDetails = await getProductFromHeroProduct({
      currencyConversionRate,
      customerCurrency,
      heroProductUrl,
      productIdExtractCode,
      storeId
    });

    if (productDetails) {
      const product = formatProduct(productDetails, currency);
      return { product, productType: product.productType, productUrl: productUrl };
    }
  }
  console.debug({ message: `Fall back to hero product`, productType });
  return { productType };
};

export default loadInitialProduct;
